import { useState, useEffect, KeyboardEvent, useRef } from "react";
import { useNavigate } from "@remix-run/react";
import axios from "axios";
import '../styles/app.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUpRightFromSquare, faSave } from "@fortawesome/free-solid-svg-icons";
import { useLocation } from "@remix-run/react";
import { useDebounce } from '../hooks/useDebounce';
import { rankFilterSuggestions } from '../screener-app/screenerIdeaQuery.util';
interface ScreenerFilter {
    name: string;
    key: string;
    shortDescription: string;
}

interface ScreenerSectionProps {
    filterList: FilterItem[];
    isHomePage: boolean;
    handleFilterDataApi: (queryArr: string[]) => void;
    onScreenerQueryAppend: (queryArr: string[]) => void;
    isDesktop: boolean;
    isActive: boolean;
    isInputFocused: boolean;
    userId: string;
    isAuthenticated: boolean;
    onAddChecklist: (data: any) => void;
    onQuerySubmit: (data: any) => void;
    isDuplicate: boolean;
    setIsDuplicate: (isDuplicate: boolean) => void;
    onShowPanelClick?: (panelName: any, e: any) => void;
}

export interface FilterItem {
    name: string;
    key: string;
    isText: boolean;
    operatorSuggestions: string[];
    shortDescription: string;
    type: string;
    is_amount_filter?: boolean;
    values: Array<string | { name: string; value: string }>;
    filter_type?: string;
    example_text?: string;
    glossary_key?: string;
}

// Add interface for column definition
interface DataTableColumn {
    name: string;
    selector: (row: any) => any;
    sortable: boolean;
    sortFunction?: (a: any, b: any) => number;
    cell?: (row: any) => JSX.Element | string;
}

const EvaluationInputBox: React.FC<ScreenerSectionProps> = ({ filterList, isHomePage, handleFilterDataApi, onScreenerQueryAppend, isDesktop, isActive, isInputFocused, userId, isAuthenticated, onAddChecklist, onQuerySubmit, isDuplicate, setIsDuplicate, onShowPanelClick: onShowPanelClickProp }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [isFiltersOpen, setFiltersOpen] = useState(false);
    const [activeSuggestion, setActiveSuggestion] = useState<number>(0);
    const [showSuggestions, setShowSuggestions] = useState(false);
    const suggestionsRef = useRef<HTMLDivElement>(null);
    const inputRef = useRef<HTMLTextAreaElement>(null);
    const [filteredSuggestions, setFilteredSuggestions] = useState<FilterItem[]>(filterList);
    const [currentStep, setCurrentStep] = useState(1);
    const [queryArr, setQueryArr] = useState<string[]>([]);
    const [displayArr, setDisplayArr] = useState<string[]>([]);
    const [queryOriginalArr, setQueryOriginalArr] = useState<string[]>([]);
    const [apiDataArr, setApiDataArr] = useState<string[]>([]);
    const [searchTerm, setsearchTerm] = useState('');
    const [activeObjArr, setActiveObjArr] = useState<any[]>([]);
    const [operatorArray, setOperatorArray] = useState<any[]>([]);
    const [valuesArray, setValuesArray] = useState<any[]>([]);
    const [textValue, setTextValue] = useState("");
    const [inputTextValue, setInputTextValue] = useState("");
    const [bigIntFilters, setBigIntFilters] = useState([
        "free_cash_flow_avg_4q",
        "free_cash_flow_avg_6q",
        "revenue_last_quarter",
        "net_income_last_quarter",
        "gross_profit_last_quarter",
        "revenue_ttm",
        "net_income_ttm",
        "gross_profit_ttm",
        "market_cap",
        "total_assets",
        "total_current_assets",
        "total_non_current_assets",
        "total_liabilities",
        "total_current_liabilities",
        "total_non_current_liabilities",
        "total_equity",
        "enterprise_value_ttm",
        "ebitda"
    ]);
    const [currentPage, setCurrentPage] = useState(1);
    const [columnHeader, setColumnHeader] = useState<string[]>([]);
    const [totalPages, setTotalPages] = useState(0);
    const [headerObj, setHeaderObj] = useState<DataTableColumn[]>([]);
    const [columnBodyRows, setColumnBodyRows] = useState<string[]>([]);
    const [filteredData, setFilteredData] = useState<any[]>([]);
    const [filteredKeys, setFilteredKeys] = useState<string[]>([]);
    const [keyMap, setkeyMap] = useState<any>({});
    const [tickerListData, setTickerListData] = useState<any[]>([]);
    const [showSaveFilterModal, setShowSaveFilterModal] = useState(false);
    const [activeEducationElementId, setActiveEducationElementId] = useState<string | null>(null);
    const abortControllerRef = useRef<AbortController | null>(null);
    const [isLoading, setIsLoading] = useState(true);
    const [isMobileFocused, setIsMobileFocused] = useState(false);
    const [isSignInModalOpen, setIsSignInModalOpen] = useState(false);
    const [showTextAreaModal, setShowTextAreaModal] = useState(false);
    const isClickingSuggestion = useRef(false);



    const searchFilterObject = (searchKey: string): FilterItem | undefined => {

        let filterObject = filterList.find(filter => filter.key.toLowerCase() === searchKey.toLowerCase());

        if (filterObject) {
            return filterObject;
        }
        return filterList.find(filter => filter.name.toLowerCase() === searchKey.toLowerCase());
    };

    const debouncedTextValue = useDebounce(textValue, 150);

    useEffect(() => {

        if (isDuplicate) {
            setDisplayArr([]);
            setQueryArr([]);
            setApiDataArr([]);
            setQueryOriginalArr([]);
            setsearchTerm("");
            setTextValue("");
            setInputTextValue("");
            setActiveSuggestion(0);
            setCurrentStep(1);
        }
    }, [isDuplicate]);

    useEffect(() => {
        // displayArr =  ['industry = medical_distribution'] to display in the input box
        const result = [];
        for (let i = 0; i < queryArr.length; i += 3) {
            const block = queryArr.slice(i, i + 3).join(' ');
            result.push(block);
        }

        setDisplayArr(result);

    }, [queryArr]);

    useEffect(() => {
        setFilteredSuggestions(rankFilterSuggestions(filterList, debouncedTextValue));
        setTextValue(debouncedTextValue);
    }, [debouncedTextValue, filterList]);


    const handleKeyDown = (e: KeyboardEvent<HTMLTextAreaElement>) => {
        if (!showSuggestions) return;

        switch (e.key) {
            case "ArrowDown":

                if (Number.isInteger(currentStep)) {

                    setActiveSuggestion((prev) => (prev < filteredSuggestions.length - 1 ? prev + 1 : 0));
                } else {
                    if (currentStep.toString().split('.')[1] === '1') {
                        setActiveSuggestion((prev) => (prev < operatorArray.length - 1 ? prev + 1 : 0));
                    }
                    if (currentStep.toString().split('.')[1] === '2') {
                        setActiveSuggestion((prev) => (prev < valuesArray.length - 1 ? prev + 1 : 0));
                    }

                }
                break;
            case "ArrowUp":
                // e.preventDefault();

                if (Number.isInteger(currentStep)) {
                    setActiveSuggestion((prev) => (prev > 0 ? prev - 1 : filteredSuggestions.length - 1));
                } else {
                    if (currentStep.toString().split('.')[1] === '1') {
                        setActiveSuggestion((prev) => (prev > 0 ? prev - 1 : operatorArray.length - 1));
                    }
                    if (currentStep.toString().split('.')[1] === '2') {
                        setActiveSuggestion((prev) => (prev > 0 ? prev - 1 : valuesArray.length - 1));
                    }
                }
                break;
            // case " ":
            //     // e.preventDefault();

            //     if (Number.isInteger(currentStep)) {
            //         if (filteredSuggestions.length) {
            //             const selectedSuggestion = filteredSuggestions[activeSuggestion];
            //             if (queryArr.length > 0 && Number.isInteger(currentStep)) {

            //                 if (isHomePage) {
            //                     if (activeSuggestion === -1) {

            //                         const encodedQuery = encodeURIComponent(displayArr.join('and'));
            //                         navigate(`/screener?query=${encodedQuery}`);
            //                     } else {
            //                         handleSuggestionClick(selectedSuggestion);
            //                         setActiveSuggestion(0);
            //                         setFilteredSuggestions(filterList);
            //                         setShowSuggestions(true);
            //                         inputRef.current && inputRef.current.focus();
            //                     }
            //                 } else {
            //                     if (activeSuggestion === -1) {
            //                         // api call function
            //                         handleFilterDataApi(queryArr);
            //                         setShowSuggestions(false);

            //                     } else {

            //                         handleSuggestionClick(selectedSuggestion);
            //                         setActiveSuggestion(0);
            //                         setFilteredSuggestions(filterList);
            //                         setShowSuggestions(true);
            //                         inputRef.current && inputRef.current.focus();
            //                     }

            //                 }

            //             } else {

            //                 handleSuggestionClick(selectedSuggestion);
            //                 setActiveSuggestion(0);
            //                 setFilteredSuggestions(filterList);
            //                 setShowSuggestions(true);
            //                 inputRef.current && inputRef.current.focus();
            //             }
            //         }
            //     } else {
            //         if (currentStep.toString().split('.')[1] === '1') {

            //             const selectedSuggestion = operatorArray[activeSuggestion];

            //             handleSuggestionClick(selectedSuggestion);
            //             setActiveSuggestion(0);
            //             inputRef.current && inputRef.current.focus();
            //         }
            //         if (currentStep.toString().split('.')[1] === '2' && !activeObjArr[activeObjArr.length - 1].isText) {
            //             // console.log('space hitted is not Text');
            //             // const selectedSuggestion = valuesArray[activeSuggestion];


            //             // handleSuggestionClick(selectedSuggestion.value);
            //             // setActiveSuggestion(-1);
            //             // inputRef.current && inputRef.current.focus();
            //         }
            //         if (currentStep.toString().split('.')[1] === '2' && activeObjArr[activeObjArr.length - 1].isText) {

            //             if (activeObjArr[activeObjArr.length - 1].values.length === 1) {
            //                 //the user should enter the value in the input box like number_of_employees= 3000

            //                 if (textValue.match(/^\d/)) {
            //                     const suggestion = valuesArray[activeSuggestion];
            //                     const selectedSuggestion = textValue + suggestion;
            //                     handleSuggestionClick(selectedSuggestion);

            //                     inputRef.current && inputRef.current.focus();
            //                 } else {
            //                     return;
            //                 }
            //             } else {
            //                 //the user should enter the value in the input box like market_cap= 30B

            //                 if (textValue.match(/^\d/)) {
            //                     const suggestion = valuesArray[activeSuggestion];
            //                     handleSuggestionClick(textValue + suggestion);
            //                 } else {
            //                     return;
            //                 }
            //                 // handleSuggestionClick(textValue.match(/^\d/) ? textValue + suggestion : suggestion)
            //             }
            //         }
            //     }

            //     break;
            case "Enter":

                e.preventDefault();

                if (Number.isInteger(currentStep)) {
                    if (filteredSuggestions.length) {
                        const selectedSuggestion = filteredSuggestions[activeSuggestion];
                        if (queryArr.length > 0 && Number.isInteger(currentStep)) {

                            if (isHomePage) {
                                if (activeSuggestion === -1) {

                                    const encodedQuery = encodeURIComponent(displayArr.join('-'));
                                    navigate(`/screener?query=${encodedQuery}`);
                                } else {
                                    handleSuggestionClick(selectedSuggestion);
                                    setActiveSuggestion(0);
                                    setFilteredSuggestions(filterList);
                                    setShowSuggestions(true);
                                    inputRef.current && inputRef.current.focus();
                                }
                            } else {
                                if (activeSuggestion === -1) {
                                    handleFilterDataApi(
                                        apiDataArr.length === queryArr.length && apiDataArr.length > 0
                                            ? apiDataArr
                                            : queryArr
                                    );
                                    setShowSuggestions(false);

                                } else {

                                    handleSuggestionClick(selectedSuggestion);
                                    setActiveSuggestion(0);
                                    setFilteredSuggestions(filterList);
                                    setShowSuggestions(true);
                                    inputRef.current && inputRef.current.focus();
                                }

                            }

                        } else {

                            handleSuggestionClick(selectedSuggestion);
                            setActiveSuggestion(0);
                            setFilteredSuggestions(filterList);
                            setShowSuggestions(true);
                            inputRef.current && inputRef.current.focus();
                        }
                    }
                } else {
                    if (currentStep.toString().split('.')[1] === '1') {

                        const selectedSuggestion = operatorArray[activeSuggestion];

                        handleSuggestionClick(selectedSuggestion);
                        setActiveSuggestion(0);
                        inputRef.current && inputRef.current.focus();
                    }
                    if (currentStep.toString().split('.')[1] === '2' && !activeObjArr[activeObjArr.length - 1].isText) {
                        const selectedSuggestion = valuesArray[activeSuggestion];


                        handleSuggestionClick(selectedSuggestion.value);
                        setActiveSuggestion(-1);
                        inputRef.current && inputRef.current.focus();
                    }
                    if (currentStep.toString().split('.')[1] === '2' && activeObjArr[activeObjArr.length - 1].isText) {


                        if (activeObjArr[activeObjArr.length - 1].values.length === 1) {
                            //the user should enter the value in the input box like number_of_employees= 3000

                            if (textValue.match(/^\d/)) {
                                const suggestion = valuesArray[activeSuggestion];
                                const selectedSuggestion = textValue + suggestion;
                                handleSuggestionClick(selectedSuggestion);

                                inputRef.current && inputRef.current.focus();
                            } else {
                                return;
                            }
                        } else {
                            //the user should enter the value in the input box like market_cap= 30B

                            if (textValue.match(/^\d/)) {
                                const suggestion = valuesArray[activeSuggestion];
                                handleSuggestionClick(textValue + suggestion);
                            } else {
                                return;
                            }
                            // handleSuggestionClick(textValue.match(/^\d/) ? textValue + suggestion : suggestion)
                        }
                    }
                }

                break;

            case "Backspace":
                e.preventDefault();
                // CHANGE (big_number): See "delete one character" branch below for 3 vs 4 options when Backspace is pressed.

                if (currentStep >= 1 || textValue.length <= 0) {

                    if (queryArr.includes(textValue.length > 0 ? textValue : queryArr.slice(-1).join(""))) {

                        let searchValue = queryArr.slice(0, queryArr.length - 1).join(' ');
                        let splitArr = queryArr.slice(0, queryArr.length - 1);
                        setQueryArr(splitArr);
                        setQueryOriginalArr(splitArr);
                        setApiDataArr((prev) => prev.slice(0, splitArr.length));
                        setsearchTerm(searchValue);

                        setCurrentStep((prevState) => {
                            if (Number.isInteger(prevState)) {

                                // If the previous state is an integer, subtract 0.7 from it
                                // alert(`${prevState},${currentStep}`);
                                // let valuesArrayList = activeObjArr[parseInt((currentStep).toString().split('.')[0]) - 2]["filter_type"] === "big_number" ? [...activeObjArr[parseInt((currentStep).toString().split('.')[0]) - 2]["values"], ...bigIntFilters] : [...activeObjArr[parseInt((currentStep).toString().split('.')[0]) - 2]["values"];
                                //  let valuesArrayList = activeObjArr[activeObjArr.length - 1]["filter_type"] === "big_number" ? [...activeObjArr[activeObjArr.length - 1]["values"]] : [...activeObjArr[activeObjArr.length - 1]["values"]];
                                let valuesArrayList = [...activeObjArr[activeObjArr.length - 1]["values"]];
                                let valuesArray = activeObjArr.length > 0 ? valuesArrayList : [];
                                let operatorArray = activeObjArr.length > 0 ? activeObjArr[activeObjArr.length - 1]["operatorSuggestions"] : [];
                                setValuesArray(valuesArray);
                                setOperatorArray(operatorArray);
                                setActiveSuggestion(0);
                                return parseFloat((prevState - 0.8).toFixed(1)); // Convert to float and fix to one decimal place

                            } else {
                                // If the previous state is already a float, subtract 0.1 from it

                                if (prevState.toString().split('.')[1] === "1") {

                                    let resultArr = activeObjArr.slice(0, -1);

                                    let valuesArray = activeObjArr[activeObjArr.length - 1]["values"];
                                    let operatorArray = activeObjArr[activeObjArr.length - 1]["operatorSuggestions"];
                                    setValuesArray(valuesArray);
                                    setOperatorArray(operatorArray);
                                    setActiveObjArr(resultArr);
                                }
                                if (prevState.toString().split('.')[1] === "2") {

                                    let valuesArray = activeObjArr[activeObjArr.length - 1]["values"];
                                    let operatorArray = activeObjArr[activeObjArr.length - 1]["operatorSuggestions"];



                                    setValuesArray(valuesArray);
                                    setOperatorArray(operatorArray);
                                    setActiveSuggestion(0);
                                }
                                if (prevState.toString().split('.')[1] === "3") {
                                    let valuesArray = activeObjArr.length > 0 ? activeObjArr[activeObjArr.length - 1]["values"] : [];
                                    let operatorArray = activeObjArr[activeObjArr.length - 1]["operatorSuggestions"];

                                    setValuesArray(valuesArray);
                                    setOperatorArray(operatorArray);
                                    setActiveSuggestion(0);
                                }
                                return parseFloat((prevState - 0.1).toFixed(1)); // Convert to float and fix to one decimal place
                            }
                        });
                    } else {
                        // Delete one character – handleInputChange is not triggered on Backspace,
                        // so we update value state and dropdown options here.
                        let newSearchValue = searchTerm.split('').slice(0, -1).join('');
                        setsearchTerm(newSearchValue);
                        let newSearchTextValue = textValue.split('').slice(0, -1).join('');
                        setTextValue(newSearchTextValue);
                        let newSearchInputTextValue = inputTextValue.split('').slice(0, -1).join('');
                        setInputTextValue(newSearchInputTextValue);
                        let operatorArray = activeObjArr.length > 0 ? activeObjArr[activeObjArr.length - 1]["operatorSuggestions"] : [];
                        setOperatorArray(operatorArray);

                        // Build the values dropdown for the shortened value.
                        // For big_number:
                        // - empty value          -> base units only (M, B, T)
                        // - value starts with 0  -> single option that shows the raw input (0, 012, etc.)
                        // - other positive value -> 4 options (value, valueM, valueB, valueT)
                        let valuesArrayList: any[] = [];
                        if (activeObjArr.length > 0) {
                            const lastFilter = activeObjArr[activeObjArr.length - 1];
                            const isBigNumber = lastFilter["filter_type"] === "big_number";

                            if (newSearchValue === "") {
                                // When user cleared the value, fall back to the filter's base values.
                                valuesArrayList = lastFilter["values"];
                            } else if (isBigNumber) {
                                if (newSearchValue.startsWith("0")) {
                                    // For 0-prefixed values (0, 012 etc.) show only one option.
                                    valuesArrayList = [""];
                                } else {
                                    // For normal positive values show raw + M/B/T options.
                                    valuesArrayList = ["", ...lastFilter["values"]];
                                }
                            } else {
                                // Non-big_number filters just reuse their own values.
                                valuesArrayList = lastFilter["values"];
                            }
                        }

                        let valuesArray = activeObjArr.length > 0 ? valuesArrayList : [];
                        setValuesArray(valuesArray || []);

                        setShowSuggestions(true);
                        setActiveSuggestion(0);
                    }
                } else {

                    // if (Number.isInteger(currentStep)) {
                    //     setFilteredSuggestions(filterList);
                    // }
                    let newSearchValue = searchTerm.split('').slice(0, -1).join('');
                    setsearchTerm(newSearchValue);
                    let newSearchTextValue = textValue.split('').slice(0, -1).join('');
                    setTextValue(newSearchTextValue);
                    let newSearchInputTextValue = inputTextValue.split('').slice(0, -1).join('');
                    setInputTextValue(newSearchInputTextValue);
                    let valuesArray = activeObjArr.length > 0 ? activeObjArr[activeObjArr.length - 1]["values"] : [];
                    setValuesArray(valuesArray);
                    let operatorArray = activeObjArr.length > 0 ? activeObjArr[activeObjArr.length - 1]["operatorSuggestions"] : [];
                    setOperatorArray(operatorArray);

                    setShowSuggestions(true);
                    setActiveSuggestion(0);
                }
                break;
            default:
                break;
        }
    };

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (suggestionsRef.current && !suggestionsRef.current.contains(event.target as Node)) {
                setShowSuggestions(false);
                setActiveSuggestion(-1);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);


    useEffect(() => {
        if (activeSuggestion >= 0 && suggestionsRef.current) {
            const suggestionsList = suggestionsRef.current.querySelector('.suggestions-list');
            const selectedElement = suggestionsList?.children[activeSuggestion] as HTMLElement;

            if (selectedElement && suggestionsList) {
                const containerHeight = suggestionsList.clientHeight;
                const scrollTop = suggestionsList.scrollTop;
                const elementTop = selectedElement.offsetTop;
                const elementHeight = selectedElement.offsetHeight;

                // Scroll down if element is below viewport
                if (elementTop + elementHeight > scrollTop + containerHeight) {
                    suggestionsList.scrollTop = elementTop + elementHeight - containerHeight;
                }
                // Scroll up if element is above viewport
                else if (elementTop < scrollTop) {
                    suggestionsList.scrollTop = elementTop;
                }
            }
        }
    }, [activeSuggestion]);

    const handleInputChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {

        event.preventDefault();
        const inputValue = event.target.value;

        if (Number.isInteger(currentStep)) {
            // Ranked search — results are scored and sorted by relevance (see rankFilterSuggestions).
            // This fires immediately on each keystroke; the debounced useEffect is the authoritative path,
            // but updating here avoids a visible 150 ms lag while the user types.
            setFilteredSuggestions(rankFilterSuggestions(filterList, inputValue));
            setTextValue(inputValue);
        } else {
            // if the current step is 1.1
            if (currentStep.toString().split('.')[1] === '1') {

                let operatorArray = activeObjArr[activeObjArr.length - 1]["operatorSuggestions"];
                const filtered = operatorArray.filter((item: any) =>
                    item.toLowerCase().includes(inputValue.toLowerCase())
                );
                setOperatorArray(filtered);


                let operators = [">", "<", ">=", "<=", "="];

                if (operators.includes(inputValue) == false) {
                    setOperatorArray(operatorArray);

                    return
                }

            }
            if (currentStep.toString().split('.')[1] === '2') {

                let istextValue = activeObjArr[activeObjArr.length - 1].type;

                switch (istextValue) {
                    case "int":

                        // regex to accept integers only
                        // let intAlphabetRegex = /^[0-9a-zA-Z_]+$/; 
                        let intAlphabetRegex = /^[0-9]+$/;
                        if (intAlphabetRegex.test(inputValue)) {

                            if (inputValue.match(/^\d/)) {
                                // When the first character is a number we are choosing value suggestions.
                                const lastFilter = activeObjArr[activeObjArr.length - 1];
                                const isBigNumber = lastFilter["filter_type"] === "big_number";

                                let valueArray: any[] = [];

                                if (isBigNumber) {
                                    // For big_number:
                                    // - empty is handled elsewhere as base units (M, B, T)
                                    // - value starts with 0 -> single option (raw value only)
                                    // - other values        -> 4 options (value, valueM, valueB, valueT)
                                    if (inputValue.startsWith("0")) {
                                        valueArray = [""];
                                    } else {
                                        valueArray = ["", ...lastFilter["values"]];
                                    }
                                } else {
                                    // For normal int filters reuse their configured values.
                                    valueArray = [...lastFilter["values"]];
                                }
                                setValuesArray(valueArray);
                            } else {

                                let valueArray = [...bigIntFilters];
                                const filtered = valueArray.filter(item =>
                                    item.toLowerCase().includes(inputValue.toLowerCase())
                                );
                                setValuesArray(filtered);
                            }
                        } else {

                            return;
                        }
                        break;
                    case "float":

                        const regex = /^[+-]?(?:\d+(?:\.\d*)?|\.\d+)$/;
                        if (regex.test(inputValue)) {

                            let valueArray = activeObjArr[activeObjArr.length - 1]["values"];
                            setValuesArray(valueArray);

                        } else {

                            return;
                        }
                        break;
                    default:
                        // default case for the filter type is string

                        let valueArray = activeObjArr[activeObjArr.length - 1]["values"];
                        const filtered = valueArray.filter((item: any) =>
                            item.name.toLowerCase().includes(inputValue.trim().toLowerCase())
                        );


                        setValuesArray(filtered);

                }
            }
        }
        setInputTextValue(inputValue);
        setTextValue(inputValue);
        setActiveSuggestion(0);
        setsearchTerm(inputValue);
        setShowSuggestions(true);
    }


    const handleSuggestionClick = (suggestItem: any) => {
        isClickingSuggestion.current = true;  // Set flag before handling click
        setIsDuplicate(false);
        setTextValue("");
        // if the current step is integer, then we are in the first step like 1
        if (Number.isInteger(currentStep)) {

            // Display triple uses filter name; API flat uses key (matches screener / checklist canonical query).
            setApiDataArr((prevArr) => [...prevArr, suggestItem.key]);
            setQueryArr((prevArr) => {
                const result = [...prevArr, suggestItem.name];
                setsearchTerm(result.join(' '));
                return result;
            });

            setQueryOriginalArr((prevArr) => {
                const result = [...prevArr, suggestItem.name];
                return result;
            });
            // Increment step by 0.1
            setCurrentStep((prevState) => parseFloat((prevState + 0.1).toFixed(1)));
            setActiveObjArr((prevArr) => [...prevArr, suggestItem]);
            let operatorArrayList = suggestItem["operatorSuggestions"];
            setOperatorArray(operatorArrayList);
            setFilteredSuggestions(filterList);
            inputRef.current && inputRef.current.focus();
        }
        else if (currentStep.toString().split('.')[1] === '1') {
            // if the current step is 1.1
            if (activeObjArr[activeObjArr.length - 1]["filter_type"] === "big_number") {

                if (suggestItem.length >= 1) {

                    const cleanedSuggestItem = suggestItem.replace(/\(Millons\)|\(Billions\)|\(Trillions\)/g, '').trim();
                    setApiDataArr((prevArr) => [...prevArr, cleanedSuggestItem]);
                    setQueryArr((prevArr) => {
                        const result = [...prevArr, cleanedSuggestItem];
                        setsearchTerm(result.join(' '));
                        return result;
                    });
                    setQueryOriginalArr((prevArr) => {
                        const result = [...prevArr, cleanedSuggestItem];
                        return result;
                    });
                    setCurrentStep((prevState) => parseFloat((prevState + 0.1).toFixed(1)));
                } else {
                    return;
                }
            } else {
                setApiDataArr((prevArr) => [...prevArr, suggestItem]);
                setQueryArr((prevArr) => {
                    const result = [...prevArr, suggestItem];
                    setsearchTerm(result.join(' '));
                    return result;
                });
                setQueryOriginalArr((prevArr) => {
                    const result = [...prevArr, suggestItem];
                    return result;
                });
                setCurrentStep((prevState) => parseFloat((prevState + 0.1).toFixed(1)));

            }

            if (activeObjArr[activeObjArr.length - 1]["filter_type"] === 'big_number') {

                let valuesArray = [...activeObjArr[activeObjArr.length - 1]["values"]];
                setValuesArray(valuesArray);
            } else {
                let valuesArray = [...activeObjArr[activeObjArr.length - 1]["values"]];

                setValuesArray(valuesArray);
            }
            inputRef.current && inputRef.current.focus();
        } else {

            // Final value: keep API flat and display triple aligned for checklist + screenerUrl dedup.
            if(activeObjArr[activeObjArr.length - 1]["filter_type"] === 'big_number' && suggestItem.length >= 1) {
                let text= suggestItem.match(/^\d/);
                if(!text) {
                    return;
                }
               }
            const displayTriple = [...queryArr, suggestItem];
            const apiTriple = [...apiDataArr, suggestItem];

            setApiDataArr((prevArr) => [...prevArr, suggestItem]);
            setQueryArr((prevArr) => {
                const result = [...prevArr, suggestItem];
                setsearchTerm(result.join(' '));
                return result;
            });
            setQueryOriginalArr((prevArr) => {
                const result = [...prevArr, suggestItem];
                return result;
            });
            setCurrentStep((prevState) => {
                // If the previous state is 3.4, increment it to 4
                let result = prevState.toString().split('.')[0];
                return parseFloat(result) + 1;
            });
            setActiveSuggestion(-1);

            setShowSuggestions(false);

            let dataObj = [{
                query: apiTriple.join(' '),
                displayLabel: displayTriple.join(' '),
                user_id: userId,
                short_description: activeObjArr[activeObjArr.length - 1].shortDescription,
                name: activeObjArr[activeObjArr.length - 1].name,
                key: activeObjArr[activeObjArr.length - 1].key,
                filter_type: activeObjArr[activeObjArr.length - 1].filter_type,
                glossary_key: activeObjArr[activeObjArr.length - 1].glossary_key
            }];

            onQuerySubmit(dataObj);
        }
        setInputTextValue('');
    }

    const onViewExample = (query: string) => {

        if (isHomePage) {

            navigate(`/screener?query=${query}`);
        } else {
            setTextValue('');
            let queryList = query.split(' ');
            let dataArr: string[] = [];
            const filtered = filterList.filter((item: any) =>
                item.key.toLowerCase() === queryList[0].toLowerCase()
            );

            if (filtered.length > 0 && filtered[0].type === 'int' || filtered.length > 0 && filtered[0].type === 'float') {
                setQueryOriginalArr(queryList);
                dataArr = queryList
            } else {
                let valueList = filtered[0]["values"];

                if (valueList.length > 0) {

                    let dataValue: any[] = []
                    valueList.forEach((item: any, index: number) => {
                        if (item.value.toLowerCase() === queryList[2].toLowerCase()) {
                            dataValue.push(item);
                        }
                    });

                    dataArr = [queryList[0], queryList[1], dataValue[0].value];
                    setQueryOriginalArr([queryList[0], queryList[1], dataValue[0].value]);
                }


            }

            setActiveObjArr(filtered);
            setCurrentStep(2);
            setQueryArr(queryList);
            setApiDataArr(dataArr.length ? dataArr : queryList);
            setsearchTerm(query);
            handleFilterDataApi(dataArr);
            setFiltersOpen(false);
            setShowSuggestions(false);
        }
    }


    const onShowPanelClick = (panelName: any, e: any) => {
        e.stopPropagation();
        setShowSuggestions(false);
        if (onShowPanelClickProp) {
            onShowPanelClickProp(panelName, e);
        } else {
            // Fallback to local behavior if prop not provided
            setActiveEducationElementId(panelName);
            setFiltersOpen(true);
        }
    }

    const handleCloseFilters = () => {
        setFiltersOpen(false);
        setActiveEducationElementId(null);
    }

    const onTextAreaClick = (e: React.MouseEvent<HTMLTextAreaElement>) => {
        e.stopPropagation(); // Prevent the event from bubbling up to parent elements
        e.preventDefault();
        if (isDesktop) {
            if (queryArr.length > 2) {
                setShowSuggestions(false);
            } else {
                setShowSuggestions(true);
                setActiveSuggestion(0);
            }

        } else {
            if (isActive) {
                setShowSuggestions(true);
                setActiveSuggestion(0);
            } else {
                setShowSuggestions(false);
                setShowTextAreaModal(true);
            }

        }
    }

    const handleBoxClick = (e: React.MouseEvent<HTMLDivElement>) => {
        e.stopPropagation();
        e.preventDefault();
        if (isDesktop) {
            if (queryArr.length > 2) {

                setShowSuggestions(false);
            } else {

                inputRef.current && inputRef.current.focus();
                setShowSuggestions(true);
                setActiveSuggestion(0);
            }

        } else {
            if (isActive) {
                inputRef.current && inputRef.current.focus();
                setShowSuggestions(true);
                setActiveSuggestion(0);
            } else {
                setShowSuggestions(false);
                setShowTextAreaModal(true);
            }
        }

    }

    useEffect(() => {

        setShowSuggestions(true);
        setActiveSuggestion(0);
        inputRef.current?.focus();
    }, []);

    return (
        <>
            <div className="grid grid-cols-4 gap-4 min-h-[50px]">
                <div className="col-span-4">
                    <div className="relative md:p-0 max-w-auto md:max-w-3xl lg:max-w-3xl mx-auto" ref={suggestionsRef}>

                        <div className="border-2 border-gray-700 rounded-lg p-1 w-full min-h-[40px] bg-white cursor-pointer" onClick={handleBoxClick}>
                            <div className="flex flex-wrap w-full">
                                {displayArr.map((item, index) => (
                                    queryArr.slice(index * 3, index * 3 + 3).length === 3 ? (
                                        <div
                                            key={index}
                                            className="inline-flex items-center bg-gradient-to-r from-emerald-700 to-teal-700 text-white text-xs md:text-[13px] font-semibold mr-2 mb-2 px-2.5 rounded-lg"
                                        >
                                            {item}
                                        </div>
                                    ) : (
                                        <div key={index} className="text-black text-xs md:text-sm font-medium mb-2 py-1 rounded break-words">
                                            {item}
                                        </div>
                                    )
                                ))}

                                <textarea
                                    className="flex-1 p-1 border-none min-w-[100px] outline-none resize-none h-8 focus:outline-none focus:ring-0"
                                    onClick={onTextAreaClick}
                                    onKeyDown={handleKeyDown}
                                    onChange={handleInputChange}
                                    ref={inputRef}
                                    placeholder={queryArr.length > 0 ? "" : "Add new criteria..."}
                                    value={textValue}
                                />
                            </div>
                        </div>

                        {(showSuggestions && filteredSuggestions.length > 0 && Number.isInteger(currentStep)) && (
                            <div className="absolute left-2 right-2 lg:left-1 lg:right-1 mt-0 bg-zinc-900 rounded-lg shadow-lg border border-zinc-700 z-10 max-h-[300px] overflow-y-scroll overflow-x-hidden [&::-webkit-scrollbar]:block [&::-webkit-scrollbar]:w-[5px] md:[&::-webkit-scrollbar]:w-2 [&::-webkit-scrollbar-thumb]:bg-zinc-600 [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-track]:bg-zinc-800 suggestions-list">
                                {filteredSuggestions.map((suggestion, index) => (
                                    <div
                                        role="button"
                                        tabIndex={0}
                                        key={index}
                                        className={`px-3 py-3 border-l-4 cursor-pointer border-b border-zinc-700/80 last:border-b-0 transition-colors duration-150 ${activeSuggestion === index ? 'bg-zinc-700 border-l-green-400 ring-1 ring-inset ring-green-500/35 hover:bg-zinc-600' : 'border-l-transparent hover:bg-zinc-800/90'
                                            }`}
                                        onMouseEnter={() => setActiveSuggestion(index)}
                                        onClick={() => handleSuggestionClick(suggestion)}

                                    >
                                        <div className="space-y-2 text-start">
                                            <div className="flex min-w-0 items-center gap-3">
                                                <span className="min-w-0 flex-1 text-xs font-semibold text-zinc-100 break-words">
                                                    {suggestion.name}
                                                </span>
                                                <button
                                                    type="button"
                                                    onClick={(e) => onShowPanelClick(suggestion.glossary_key, e)}
                                                    className="inline-flex shrink-0 items-center gap-1 text-xs font-medium text-green-400 hover:text-green-300 underline-offset-2 hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-green-500 focus-visible:ring-offset-2 focus-visible:ring-offset-zinc-900 rounded-sm"
                                                >
                                                    Learn more
                                                    <FontAwesomeIcon
                                                        icon={faArrowUpRightFromSquare}
                                                        className="text-[10px] opacity-70"
                                                        aria-hidden
                                                    />
                                                </button>
                                            </div>
                                            <p className="hidden md:inline-block text-xs text-yellow-500 text-left">
                                                {suggestion.shortDescription}
                                            </p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}

                        {/* Suggestions dropdown for second step*/}
                        {(currentStep.toString().split('.')[1] === '1' && showSuggestions) && (
                            <div className="absolute left-2 right-2 lg:left-4 lg:right-4 mt-0 bg-zinc-900 rounded-lg shadow-lg border border-zinc-700 z-10 max-h-[300px] overflow-y-scroll [&::-webkit-scrollbar]:block [&::-webkit-scrollbar]:w-[5px] md:[&::-webkit-scrollbar]:w-2 [&::-webkit-scrollbar-thumb]:bg-zinc-600 [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-track]:bg-zinc-800 suggestions-list">
                                {operatorArray.map((suggestion, index) => (
                                    <div
                                        key={index}
                                        className={`px-3 py-4 border-l-4 cursor-pointer border-b border-zinc-700/80 last:border-b-0 transition-colors duration-150 ${activeSuggestion === index ? 'bg-zinc-700 border-l-green-400 ring-1 ring-inset ring-green-500/35 hover:bg-zinc-600' : 'border-l-transparent hover:bg-zinc-800/90'
                                            }`}
                                        onMouseEnter={() => setActiveSuggestion(index)}
                                        onClick={() => handleSuggestionClick(suggestion)}

                                    >
                                        <div className="space-y-2 text-start">
                                            <div className="flex items-center justify-between">
                                                <div>
                                                    <span className="text-sm font-semibold text-zinc-100 me-3">{suggestion}</span>

                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}

                        {/* Suggestions dropdown for third step and if the filter is text */}
                        {(currentStep.toString().split('.')[1] === '2' && showSuggestions && activeObjArr[activeObjArr.length - 1].isText) && (

                            activeObjArr[activeObjArr.length - 1].values.length === 1 ?
                                (
                                    //the user should enter the value in the input box like number_of_employees= 3000
                                    <div className="absolute left-2 right-2 lg:left-4 lg:right-4 mt-0 bg-zinc-900 rounded-lg shadow-lg border border-zinc-700 z-10 max-h-[300px] overflow-y-scroll [&::-webkit-scrollbar]:block [&::-webkit-scrollbar]:w-[5px] md:[&::-webkit-scrollbar]:w-2 [&::-webkit-scrollbar-thumb]:bg-zinc-600 [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-track]:bg-zinc-800 suggestions-list">
                                        {valuesArray.map((suggestion, index) => (
                                            <div
                                                key={index}
                                                className={`px-3 py-4 border-l-4 cursor-pointer border-b border-zinc-700/80 last:border-b-0 transition-colors duration-150 ${activeSuggestion === index ? 'bg-zinc-700 border-l-green-400 ring-1 ring-inset ring-green-500/35 hover:bg-zinc-600' : 'border-l-transparent hover:bg-zinc-800/90'
                                                    }`}
                                                onMouseEnter={() => setActiveSuggestion(index)}
                                                onClick={() => handleSuggestionClick(textValue + suggestion)}

                                            >
                                                <div className="space-y-2 text-start">
                                                    <div className="flex items-center justify-between">
                                                        <div>
                                                            <span className="text-sm font-semibold text-zinc-100 me-3">{textValue + suggestion}</span>
                                                            {/* <span className="inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-600/20">
                                        {suggestion.value} 
                                    </span> */}
                                                        </div>

                                                    </div>

                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )
                                : (
                                    //the user should enter the value in the input box like market_cap= 30B
                                    <div className="absolute left-2 right-2 lg:left-4 lg:right-4 mt-0 bg-zinc-900 rounded-lg shadow-lg border border-zinc-700 z-10 max-h-[300px] overflow-y-scroll [&::-webkit-scrollbar]:block [&::-webkit-scrollbar]:w-[5px] md:[&::-webkit-scrollbar]:w-2 [&::-webkit-scrollbar-thumb]:bg-zinc-600 [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-track]:bg-zinc-800 suggestions-list">
                                        {valuesArray.map((suggestion, index) => (
                                            <div
                                                key={index}
                                                className={`px-3 py-4 border-l-4 cursor-pointer border-b border-zinc-700/80 last:border-b-0 transition-colors duration-150 ${activeSuggestion === index ? 'bg-zinc-700 border-l-green-400 ring-1 ring-inset ring-green-500/35 hover:bg-zinc-600' : 'border-l-transparent hover:bg-zinc-800/90'
                                                    }`}
                                                onMouseEnter={() => setActiveSuggestion(index)}
                                                onClick={() => handleSuggestionClick(textValue.match(/^\d/) ? textValue + suggestion : suggestion)}

                                            >
                                                <div className="space-y-2 text-start">
                                                    <div className="flex items-center justify-between">
                                                        <div>
                                                            <span className="text-sm font-semibold text-zinc-100 me-3">{textValue.match(/^\d/) ? textValue + suggestion : suggestion}</span>

                                                        </div>

                                                    </div>

                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )

                        )

                        }

                        {/* Suggestions dropdown for third step and if the filter is not text like industry  and exchange */}
                        {
                            (currentStep.toString().split('.')[1] === '2' && showSuggestions && !activeObjArr[activeObjArr.length - 1].isText) &&
                            (
                                <div className="absolute left-2 right-2 lg:left-4 lg:right-4 mt-0 bg-zinc-900 rounded-lg shadow-lg border border-zinc-700 z-10 max-h-[300px] overflow-y-scroll [&::-webkit-scrollbar]:block [&::-webkit-scrollbar]:w-[5px] md:[&::-webkit-scrollbar]:w-2 [&::-webkit-scrollbar-thumb]:bg-zinc-600 [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-track]:bg-zinc-800 suggestions-list">
                                    {valuesArray.map((suggestion, index) => (
                                        <div
                                            key={index}
                                            className={`px-3 py-4 border-l-4 cursor-pointer border-b border-zinc-700/80 last:border-b-0 transition-colors duration-150 ${activeSuggestion === index ? 'bg-zinc-700 border-l-green-400 ring-1 ring-inset ring-green-500/35 hover:bg-zinc-600' : 'border-l-transparent hover:bg-zinc-800/90'
                                                }`}
                                            onMouseEnter={() => setActiveSuggestion(index)}
                                            onClick={() => handleSuggestionClick(suggestion.value)}

                                        >
                                            <div className="space-y-2 text-start">
                                                <div className="flex items-center justify-between">
                                                    <div>
                                                        <span className="text-sm font-semibold text-zinc-100 me-3">{suggestion.name}</span>
                                                        <span className="inline-flex items-center rounded-md bg-green-950/50 px-2 py-1 text-xs font-medium text-green-400 ring-1 ring-inset ring-green-500/30">
                                                            {suggestion.value}
                                                        </span>
                                                    </div>

                                                </div>

                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )
                        }
                    </div>
                </div>
            </div>
        </>
    );
};

export default EvaluationInputBox;